export default {
    props: {
        src: {
            type: String,
            default: null,
        },
        alt: {
            type: String,
            default: undefined,
        },
        width: {
            type: [Number, String],
            default: 1,
        },
        height: {
            type: [Number, String],
            default: 1,
        },
    },
    // setup(props) {},
    template: `
        <div
            v-if="src"
            class="a-asset"
        >
            <div class="a-asset_inner">
                <img
                    :src="src"
                    :alt="alt"
                    :width="width"
                    :height="height"
                    class="a-asset_element"
                >
            </div>
        </div>
    `,
}
